var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.school)?_c('div',[(_vm.rsettings[0].settings.address)?_c('small',[_vm._v("Address: "+_vm._s(_vm.school.address))]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }